// extracted by mini-css-extract-plugin
export default {"tooltip":"Wm-z","sharingV2":"Xm-z","sharingIconsV2":"Ym-z","links":"Zm-z","link":"_m-z","facebookV2":"an-z","twitterV2":"bn-z","pinterestV2":"cn-z"};